import ProjectCard from "./ProjectCard";
import WorkCardData from "./ProjectCardData";
import "./ProjectCardStyles.css";

const Project = () => (
  <div className="project-container">
    {WorkCardData.map((proj, idx) => (
      <ProjectCard
        key={idx}
        number={proj.number}
        title={proj.title}
        text={proj.text}
        view={proj.view}
        iconColor={proj.iconColor}
      />
    ))}
  </div>
);

export default Project;